import { Link } from 'gatsby'
import React from 'react'
import SbEditable from 'storyblok-react'

import TextRenderer from './../TextRenderer'
import LinkItem from './../LinkItem'

import styles from './styles.module.scss'

const GetInvolved = (props) => {
	return (
		<SbEditable content={props.blok}>
			<section className={styles['get-involved']}>
                <div className={`container ${styles['get-involved__container']}`}>
                    <TextRenderer text={props.blok.heading} className={styles['get-involved__heading']} />
                    <ul className={styles['get-involved__list']}>
                        {props.blok.links.map((blok, i) => {
                            return (
                                <LinkItem key={i} blok={blok} />
                            )
                        })}
                    </ul>
                </div>
            </section>
		</SbEditable>
	)
}

export default GetInvolved